// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Layout.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Layout.tsx");
  import.meta.hot.lastModified = "1742594446288.202";
}
// REMIX HMR END

import { Link } from "@remix-run/react";
export default function Layout({
  children,
  user
}) {
  return <div className="min-h-screen flex flex-col">
      <header className="bg-blue-600 text-white p-4">
        <div className="container mx-auto flex justify-between items-center">
          <Link to="/" className="text-xl font-bold">
            AI Brand Monitor
          </Link>
          <nav>
            <ul className="flex space-x-4">
              {user ? <>
                  <li>
                    <Link to="/brands" className="hover:underline">
                      Brands
                    </Link>
                  </li>
                  <li>
                    <Link to="/auth/logout" className="hover:underline">
                      Logout
                    </Link>
                  </li>
                </> : <li>
                  <Link to="/auth/login" className="hover:underline">
                    Login
                  </Link>
                </li>}
            </ul>
          </nav>
        </div>
      </header>

      <main className="flex-grow container mx-auto p-4">
        {children}
      </main>

      <footer className="bg-gray-100 p-4">
        <div className="container mx-auto text-center text-gray-600">
          &copy; {new Date().getFullYear()} AI Brand Monitor
        </div>
      </footer>
    </div>;
}
_c = Layout;
var _c;
$RefreshReg$(_c, "Layout");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;